module.exports = __webpack_public_path__ + "img/south-sask-bus-lines.fb91d828.png";